import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function BackToTasksButton({ companyId, sx }) {
  const navigate = useNavigate();

  const goBack = () => {
    if (companyId) {
      navigate(`/companies/${companyId}/logistics`);
    }
  };

  return (
    <Button sx={sx} onClick={goBack} variant="contained">
      Назад
    </Button>
  );
}

BackToTasksButton.propTypes = {
  companyId: PropTypes.number.isRequired,
  sx: PropTypes.shape(),
};

BackToTasksButton.defaultProps = {
  sx: {},
};

export default BackToTasksButton;
